export default __webpack_public_path__ + "static/media/friends-3042751_1920.7fb89720.jpg";